import { render, staticRenderFns } from "./DialogBuyNotice.vue?vue&type=template&id=16141299&scoped=true&"
import script from "./DialogBuyNotice.vue?vue&type=script&lang=js&"
export * from "./DialogBuyNotice.vue?vue&type=script&lang=js&"
import style0 from "./DialogBuyNotice.vue?vue&type=style&index=0&id=16141299&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16141299",
  null
  
)

export default component.exports